import React from 'react';
import classnames from 'classnames';
import { CoreLink } from '@uncinc/react-drupal-core';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import './style.scss';

interface PartnerTeaserProps {
  entity: ImmutableEntity<any>;
  className?: string;
}

const PartnerTeaser: React.FC<PartnerTeaserProps> = ({ entity, className }) => {
  const title = entity.getIn(['title', 0, 'value'], '');
  const link = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title'], 'Over deze samenwerking');
  const image = entity.getIn(['field_logo', 0, 'url']);
  const imageAlt = entity.getIn(['field_logo', 0, 'alt']);
  const subTitle = entity.getIn(['field_subtitle', 0, 'value'], '');

  return (
    <div className={classnames(className, 'Partner')}>
      <span className="Partner__subTitle">{subTitle}</span>
      {image && (
        <div className="Partner__details__avatar"><img alt={imageAlt} src={image} /></div>
      )}
      <h3 className="Partner__title asH4">{title}</h3>
      {link && (
        <CoreLink href={link} className="underline-on-hover font-normal">
          <span className="Partner__link">{linkTitle}<i className="icon icon-after icon-chevron-right" /></span>
        </CoreLink>
      )}
    </div>
  );
};

export default PartnerTeaser;
